<script lang="ts">
  import { onMount } from "svelte";
  import CustomerGrid from "../components/content/customer/CustomerGrid.svelte";

  onMount(async () => {});
</script>

<div class="app-grid inside-root">
  <CustomerGrid />
</div>
